<template>
    <v-form v-if="!success" ref="form" v-model="valid">
        <v-container class="fill-height">
            <v-row class="text-center" align="center">
                <v-col offset="2" cols="8">
                    <h2>Installation et validation d'Alfred</h2>
                </v-col>
                <v-col offset-md="4" md="4" offset="2" cols="8">
                    <v-text-field v-model="email" label="Votre email*" required :rules="emailRules"></v-text-field>
                </v-col>
                <v-col offset-md="4" md="4" offset="2" cols="8">
                    <v-radio-group v-model="sex" hide-details>
                        <template v-slot:label>
                            <div><b>Êtes vous ...</b></div>
                        </template>
                        <div class="mt-3">
                            <v-radio value="male">
                                <template v-slot:label>
                                    <div>un Homme</div>
                                </template>
                            </v-radio>
                            <v-radio value="female">
                                <template v-slot:label>
                                    <div>une Femme</div>
                                </template>
                            </v-radio>
                            <v-radio value="na">
                                <template v-slot:label>
                                    <div>Je préfère ne pas le dire</div>
                                </template>
                            </v-radio>
                        </div>
                    </v-radio-group>
                </v-col>
                <v-col offset-md="4" md="4" offset="2" cols="8">
                    <v-text-field v-model="age" type="number" label="Votre age (non obligatoire)" :rules="ageRules"></v-text-field>
                </v-col>
                <v-col offset-md="4" md="4" offset="2" cols="8" class="mt-4">
                    <p class="grey--text text--darken-1">Nous collectons vos données de navigation pour réaliser des études anonymes. Pour plus d'informations sur notre politique de confidentialité, cliquez <a href="https://www.drive.win/confidentialite" target="_blank">ici</a>. Acceptez-vous de partager vos données de navigation ?</p>
                    <v-checkbox v-model="cgu" label="J'accepte les CGU" class="mt-0" hide-details :rules="checkRules"></v-checkbox>
                    <v-checkbox v-model="tracking" label="J'accepte le tracking de mes données" :rules="checkRules"></v-checkbox>
                </v-col>
                <v-col offset="2" cols="8" class="mt-8">
                    <v-btn depressed color="primary" x-large :disabled="!valid" @click="installExt">
                        Rejoindre le programme
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
    <v-container v-else class="fill-height">
        <v-row class="text-center" align="center">
            <v-col cols="12">
                <v-icon x-large class="" color="success">mdi-check</v-icon>
            </v-col>
            <v-col cols="12">
                <h2>Merci pour votre inscription !</h2>
            </v-col>
            <v-col cols="12">
                <p>Vous pouvez commencer a profiter des avantages DriveWin en faisant vos achats sur Leclerc Drive !</p>
            </v-col>
            <v-col cols="12">
                <v-btn depressed color="primary" href="https://www.leclercdrive.fr/" x-large>
                    Commencer vos courses
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: 'Register',

    data: () => ({
        idChromeExt: process.env.NODE_ENV == "production" ? "mhdclogdlkffiklbgoaifkocdiohnfdl" : "ojjladgldckkooolnlmdkfdghcaobddl",
        valid: true,
        success: false,
        email: "",
        sex: "na",
        age: null,
        ageRules: [
            v => ((v >= 18 && v < 100) || !v) || "Vous devez avoir entre 18 et 100 ans"
        ],
        emailRules: [
            v => !!v || "Votre email est requis",
            v => /.+@.+\..+/.test(v) || 'L\'email doit être valide',
        ],
        checkRules: [v => !!v || 'Vous devez acceptez pour continuer'],
        cgu: false,
        tracking: false,
    }),
    methods: {
        async installExt() {
            try {


                console.log("process.env.NODE_ENV: ", process.env.NODE_ENV)
                console.log("this.idChromeExt: ", this.idChromeExt)
                this.$refs.form.validate()
                chrome.runtime.sendMessage(this.idChromeExt, { email: this.email, sex: this.sex, age: this.age }, resp => {
                    console.log("resp: ", resp)
                    if (!resp.success) {
                        // Extension is not installed.
                        console.log("Not installed")
                        return;
                    }
                    console.log("Installed & send")
                    if (resp.success)
                        this.success = true
                    console.log("resp: ", resp)
                });
            } catch (e) {
                // Extension is not installed.
                console.log("Not installed")
            }
        }
    }
}
</script>